import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, FileSearch, FileCheck, Mail, Trophy } from 'lucide-react';
import SEO from '../components/SEO';
import { PageHero, FeatureGrid, CTABand } from '../components/marketing';

const STEPS = [
  { Icon: FileSearch, title: 'Shortlist', desc: 'Counsellor-vetted shortlist of 8–12 programs matched to budget, fit and acceptance probability.' },
  { Icon: FileCheck, title: 'Application package', desc: 'Documents, transcripts, statement of purpose, LORs — checked, edited, courier-ready.' },
  { Icon: Mail, title: 'Submission & follow-up', desc: 'We submit on your behalf and chase admissions offices weekly until decision day.' },
  { Icon: Trophy, title: 'Offer + visa', desc: 'Once you have an offer, we walk you through deposit, visa filing, accommodations and arrival.' },
];

export default function CollegeAdmissionsPage() {
  return (
    <div className="bg-tge-paper min-h-screen">
      <SEO title="College Admissions — True Global Education" />
      <PageHero
        eyebrow="College admissions"
        title="From shortlist to acceptance letter, handled."
        intro="Most students apply to too few schools, with packages that are too thin. We fix both — at scale, with quality."
      />
      <FeatureGrid items={STEPS} columns={4} />
      <CTABand
        title="Start your application"
        body="Free 30-minute call to map out your shortlist."
        primary={
          <Link
            to="/login"
            className="bg-tge-gold hover:bg-tge-gold-soft text-tge-navy font-semibold px-7 py-3.5 rounded-full inline-flex items-center gap-2 transition"
          >
            Apply now <ArrowRight size={17} />
          </Link>
        }
      />
    </div>
  );
}
